import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { DataProvider, useStore, useSettings } from './listing-app/context/store';

import useGetListings from './listing-app/methods/useGetListings';

import Listings from './listing-app/components/Listings';
import Filters from './listing-app/components/Filters';
import Pagination from './listing-app/components/Pagination';
import SortBar from './listing-app/components/SortBar';
import Search from './filter-search/components/Search';

// let NodeLists use forEach
if ( typeof NodeList.prototype.forEach === 'undefined' ) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function ListingApp( props ) {
    const { 
        state,
        dispatch 
    } = useStore();

    const settings = useSettings();

    const {
        getListings
    } = useGetListings();

    useEffect(() => {
        getListings()        
    }, [ state.init, state.filters, state.sortBy ] )

    // On pagination change. Prevent running when state initializes.
    const firstUpdate = useRef( true );
    useEffect(() => {
        if ( firstUpdate.current ) {
            firstUpdate.current = false;
            return;
        }

        getListings( settings.perPage, state.currentPage )
    }, [ state.currentPage ]);

    return (
        <div className="ygl-app">
			<Filters />
            <SortBar />
            <Listings />
            <Pagination />
        </div>
    )
}

const app = document.getElementById( 'ygl-app' )

if ( null !== app ) {
    ReactDOM.render(
        <DataProvider>
            <ListingApp />
        </DataProvider>,
        app
    )
}